import React from 'react';
import styled from 'styled-components';

import { ModalPosition } from './index';
import { Modal, Container, Button } from 'ui/components/styled';

export const ConfirmationModal = ({
  children,
  content,
  contentProps,
  onClose,
  onConfirm,
  cancelButtonProps,
  confirmButtonProps,
  cancelButtonText,
  confirmButtonText,
  ...rest
}) => {
  const [preventConfirm, setPreventConfirm] = React.useState(false);
  const isMounted = React.useRef(false);
  const ModalContent = content || DefaultModalContent;

  const handleConfirm = async (...params) => {
    setPreventConfirm(true);
    if (onConfirm) {
      await onConfirm(...params);
    }
    if (isMounted.current) {
      setPreventConfirm(false);
    }
  };

  React.useEffect(() => {
    isMounted.current = true;

    return () => (isMounted.current = false);
  }, []);

  return (
    <Modal
      position={ModalPosition.TOP_CENTER}
      top="33%"
      maxWidth="500px"
      padding="1.5rem 2rem"
      onClose={onClose}
      {...rest}
    >
      <ModalContent
        onClose={onClose}
        onConfirm={handleConfirm}
        preventConfirm={preventConfirm}
        cancelButtonProps={cancelButtonProps}
        confirmButtonProps={confirmButtonProps}
        cancelButtonText={cancelButtonText}
        confirmButtonText={confirmButtonText}
        {...contentProps}
      >
        {children}
      </ModalContent>
    </Modal>
  );
};

const DefaultModalContent = ({
  children,
  onClose,
  onConfirm,
  preventConfirm,
  cancelButtonProps,
  confirmButtonProps,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Yes',
}) => (
  <>
    <Content mb="l">{children}</Content>
    <Container flexDirection="row" justifyContent="space-between">
      <Button
        data-testid="cancel"
        variant="contrast-primary"
        width="45%"
        boxShadow="none"
        onClick={onClose}
        {...cancelButtonProps}
        role="button"
      >
        {cancelButtonText}
      </Button>
      <Button
        data-testid="confirm"
        width="45%"
        onClick={onConfirm}
        disabled={preventConfirm}
        {...confirmButtonProps}
        role="button"
      >
        {confirmButtonText}
      </Button>
    </Container>
  </>
);

const Content = styled(Container)`
  font-weight: 500;
  color: #333;
`;
